<template>
    <div class="fill-height d-flex flex-column">

        <div id="nd-title" class="d-flex flex-column align-center pt-4 pb-2">
            <p class="text-center">
                <v-icon size="x-large" color="blue-darken-2">mdi-map</v-icon><br>
                Mappa
            </p>
            <v-divider />
        </div>
        <v-btn icon="mdi-cog" size="small" class="ma-5" :color="settingColor"
            @click="settingMode = !settingMode" />
        <v-spacer />

        <v-expansion-panels flat variant="accordion" :class="settingMode ? 'settingActive' : ''">

            <v-expansion-panel>
                <v-expansion-panel-title><v-icon color="white" class="mr-2">mdi-account</v-icon>
                    Utente</v-expansion-panel-title>
                <v-expansion-panel-text class="pa-0">



                    <p class="px-4" v-show="!settingMode">
                        <file-input @onFileAdded="geojsonFileAdded" :config="geojsonLayerFileInputConfig" />
                    </p>
                    <v-list density="compact">

                        <template v-if="!settingMode">
                            <template v-for="(layer, i) in activeUserLayers" :key="i">
                                <v-list-item v-if="layer.active">
                                    <v-switch inset v-model="layer.visible" class=""
                                        @click="toggleLayerVisibility(layer)" hide-details density="compact"
                                        color="primary" :label="layer.title"></v-switch>

                                </v-list-item>
                            </template>
                        </template>

                        <template v-else>
                            <v-list-item v-for="layer of mapStore?.userLayers" :key="i">

                                <v-switch density="compact" hide-details color="success"
                                    v-model="layer.active" @update:model-value="toggleLayerActivation(layer)"
                                    :label="layer.title" inset>
                                </v-switch>

                                <template v-slot:append>


                                    <v-dialog width="auto">
                                        <template v-slot:activator="{ props }">
                                            <v-btn icon="mdi-delete" size="x-small" v-bind="props"
                                                color="red-darken-3" />
                                        </template>

                                        <template v-slot:default="{ isActive }">
                                            <v-card theme="dark">
                                                <v-card-item>
                                                    <v-card-title>Eliminazione</v-card-title>
                                                    <v-card-subtitle>Stai per eliminare un oggetto</v-card-subtitle>
                                                </v-card-item>
                                                <v-card-text>
                                                    <p class="mb-2">
                                                        Sei sicuro di voler eliminare il file collegato a questo
                                                        livello?<br>
                                                        Non sarà più possibile visualizzare il livello, nè accedere al
                                                        file.
                                                    </p>
                                                </v-card-text>

                                                <v-card-actions class="d-flex flex-column align-center ">
                                                    <v-btn variant="flat" size="large"
                                                        color="red-darken-2" class="my-1"
                                                        @click="deleteUserLayer(layer); isActive.value = false; deleteConfirm = false;">
                                                        <v-icon>mdi-delete</v-icon>
                                                        Elimina</v-btn>
                                                    <v-btn variant="outlined" size="large" color="white"
                                                        class="my-1 mx-0"
                                                        @click="isActive.value = false; deleteConfirm = false">
                                                        <v-icon>mdi-chevron-down</v-icon>
                                                        Indietro</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </template>
                                    </v-dialog>


                                </template>
                            </v-list-item>
                        </template>

                    </v-list>

                </v-expansion-panel-text>
            </v-expansion-panel>

            <v-expansion-panel v-if="runtimeStore.session.user?.username=='marco'">
                <v-expansion-panel-title><v-icon color="white" class="mr-2">mdi-star</v-icon>
                    Annotazioni</v-expansion-panel-title>
                <v-expansion-panel-text class="pa-0">
                    <v-list>
                        <v-list-item>

                            <!-- n activeOverlayLayers" :key="i">
                                <template v-if="testerCheck(layer)">
                                    <v-list-item v-if="layer.active">
                                        <v-switch inset v-model="layer.visible" -->
                            <v-switch 
                                density="compact" 
                                class="mr-6" 
                                hide-details 
                                color="info"
                                v-model="activeAnnotazioniLayers[0].visible" 
                                @click="toggleLayerVisibility(activeAnnotazioniLayers[0])"
                                label="Personali" 
                                inset
                                >

                                        <template #append>


                                        <v-dialog width="50vw">                                            <template v-slot:activator="{ props }">
                                            <v-btn 
                                                icon="mdi-cog"
                                                variant="text"
                                                color="white"
                                                class="mrn-2"
                                                size="x-small" v-bind="props"
                                            />
                                            </template>

                                            <template v-slot:default="{ isActive }">
                                                <v-card theme="dark">
                                                    <v-card-item>
                                                        <v-card-title>{{ layer?.title ? layer.title : "Dettaglio" }}</v-card-title>
                                                    </v-card-item>
                                                    <v-card-text>
                                                        impostazioni livello:<br>
                                                        Priorità: <br>
                                                        Visibilità: <br>
                                                    </v-card-text>

                                                    <v-card-actions class="d-flex flex-column align-center ">
                                                        <v-btn variant="outlined" size="large" color="white"
                                                            class="my-1 mx-0"
                                                            @click="isActive.value = false; deleteConfirm = false">
                                                            <v-icon>mdi-chevron-down</v-icon>
                                                            Indietro</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </template>
                                        </v-dialog>
                                        </template>
                            </v-switch>
                        </v-list-item>

                        <v-list-item>

                            <v-switch 
                                density="compact" 
                                class="mr-6" 
                                hide-details 
                                color="info"
                                v-model="activeAnnotazioniLayers[1].visible" 
                                @click="toggleLayerVisibility(activeAnnotazioniLayers[1])"
                                label="Colleghi" 
                                inset
                                >

                                        <template #append>

                                        <v-dialog width="50vw">
                                            <template v-slot:activator="{ props }">
                                            <v-btn 
                                                icon="mdi-cog"
                                                variant="text"
                                                color="white"
                                                class="mrn-2"
                                                size="x-small" v-bind="props"
                                            />
                                            </template>

                                            <template v-slot:default="{ isActive }">
                                                <v-card theme="dark">
                                                    <v-card-item>
                                                        <v-card-title>{{ layer?.title ? layer.title : "Dettaglio" }}</v-card-title>
                                                    </v-card-item>
                                                    <v-card-text>
                                                        impostazioni livello:<br>
                                                        tutte : <br>
                                                        uno specifico: <br>
                                                        Priorità<br>
                                                        <v-select 
                                                        label="Aggiuntive"
                                                        v-model.number="annotazioni_colleghi" 
                                                        :items="[{title: 'Nessuno', value: 0}, {title: 'Tutti', value: -1}, {title: 'Utente 1', value: 1}, {title: 'Utente 2', value: 3}]" 
                                                        item-title="title" 
                                                        item-value="value" 
                                                        hide-details 
                                                        class="my-3">
                                                    </v-select>
                                                    </v-card-text>

                                                    <v-card-actions class="d-flex flex-column align-center ">
                                                        <v-btn variant="outlined" size="large" color="white"
                                                            class="my-1 mx-0"
                                                            @click="isActive.value = false; deleteConfirm = false">
                                                            <v-icon>mdi-chevron-down</v-icon>
                                                            Indietro</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </template>
                                        </v-dialog>
                                        </template>
                            </v-switch>
                        </v-list-item>
                    </v-list>
                </v-expansion-panel-text>
            </v-expansion-panel>



            <v-expansion-panel :is="true">
                <v-expansion-panel-title><v-icon color="white" class="mr-2">mdi-layers-triple</v-icon>
                    Overlay</v-expansion-panel-title>
                <v-expansion-panel-text class="pa-0">

                    <v-list density="compact" class="px-0">

                        <template v-if="!settingMode">
                            <template v-for="(layer, i) in activeOverlayLayers" :key="i">
                                <template v-if="testerCheck(layer)">
                                    <v-list-item v-if="layer.active">
                                        <v-switch inset v-model="layer.visible" color="primary" class="mr-0"
                                            hide-details density="compact"
                                            :label="layer.title"
                                            @click="toggleLayerVisibility(layer)"
                                            ></v-switch>

                                        <template #append>

                                        <v-dialog width="auto">
                                            <template v-slot:activator="{ props }">
                                            <v-btn 
                                                v-if="layer.description"
                                                icon="mdi-information"
                                                variant="text"
                                                color="white"
                                                class="mrn-2"
                                                size="x-small" v-bind="props"
                                            />
                                            </template>

                                            <template v-slot:default="{ isActive }">
                                                <v-card theme="dark">
                                                    <v-card-item>
                                                        <v-card-title>{{ layer?.title ? layer.title : "Dettaglio" }}</v-card-title>
                                                    </v-card-item>
                                                    <v-card-text>
                                                        <p class="mb-2" v-html="layer.description">
                                                        </p>
                                                    </v-card-text>

                                                    <v-card-actions class="d-flex flex-column align-center ">
                                                        <v-btn variant="outlined" size="large" color="white"
                                                            class="my-1 mx-0"
                                                            @click="isActive.value = false; deleteConfirm = false">
                                                            <v-icon>mdi-chevron-down</v-icon>
                                                            Indietro</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </template>
                                        </v-dialog>


                                        </template>
                                    </v-list-item>
                                </template>
                            </template>
                        </template>

                        <template v-else>
                            <v-list>
                                <v-list-item v-for="layer of mapStore?.overlayLayers" :key="i">
                                    <v-switch density="compact" class="mr-6" hide-details color="success"
                                    v-model="layer.active" @update:model-value="toggleLayerActivation(layer)"
                                    :label="layer.title" inset>
                                    </v-switch>
                                </v-list-item>
                            </v-list>
                        </template>

                    </v-list>

                </v-expansion-panel-text>
            </v-expansion-panel>


            <v-expansion-panel>
                <v-expansion-panel-title><v-icon color="white" class="mr-2">mdi-rhombus</v-icon>
                    Base</v-expansion-panel-title>
                <v-expansion-panel-text>

                    <template class="" v-if="runtimeStore.session.settings.packsDownloadLocation == 'cache'">
                        <p class="text-right">
                        <v-btn size="x-small" :to="'/offline_packages/'" color="primary" variant="outlined"
                            class="">
                            <v-icon class="mr-2" size="small">mdi-download</v-icon> Scarica
                        </v-btn>
                    </p>
                    </template> 
                    <!-- <p class="ma-2" v-if="OneToFourMBTilesPackDownloaded">
                        <v-btn size="x-small" :to="'/offline_packages/'" color="white" variant="outlined"
                            class="mt-3">
                            <v-icon class="mr-2" size="small">mdi-database</v-icon> Dati >
                            <v-icon class="mx-2" size="small">mdi-package</v-icon> Pacchetti
                        </v-btn>
                    </p> -->

                    <v-list density="compact">

                        <template v-if="!settingMode">
                            <template v-for="(layer, i) in activeBaseLayers" :key="i">
                                <v-list-item v-if="layer.active">

                                    <v-radio-group v-model="baseLayerID" hide-details density="comfortable">
                                        <v-radio :value="layer.id" color="primary"
                                            @click="setBaseLayer(layer)" :label="layer.title"></v-radio>
                                    </v-radio-group>

                                    <template v-slot:append>
                                        <v-icon size="x-small" v-if="layer.source == 'localwebserver'">mdi-server</v-icon>
                                        <v-icon size="x-small" v-if="layer.source == 'cache'">mdi-memory</v-icon>
                                        <v-icon size="x-small" v-if="layer.source == 'internet'">mdi-web</v-icon>
                                    </template>
                                </v-list-item>
                            </template>
                        </template>

                        <template v-else>
                            <v-list-item v-for="layer of mapStore?.baseLayers" :key="i">
                                <v-switch density="compact" class="mr-6" hide-details color="success"
                                    v-model="layer.active" @update:model-value="toggleLayerActivation(layer)"
                                    :label="layer.title" inset>
                                </v-switch>
                            </v-list-item>
                        </template>


                    </v-list>
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>


<script setup>


import { ref, computed, onMounted } from "vue";
import { useMapStore } from "@/store/map";
import { useRuntimeStore } from "@/store/runtime"
import FileInput from '@/components/media/FileInput.vue'

const mapStore = useMapStore();

const runtimeStore = useRuntimeStore();


const emit = defineEmits(['selectedBaseLayer', 'toggleLayer'])


const emitSelectBaseLayer = (layer) => {
    emit('selectedBaseLayer', layer)
}


const emitToggleLayer = (layer) => {
    emit('toggleLayer', layer)
}


const baseLayerID = ref(null)

const annotazioni_personali = ref(true)
const annotazioni_colleghi = ref(false)


const is_user_tester = ["marco","peracino_a"].includes(runtimeStore.session.user?.username)

const testerCheck = (layer) =>{
    if (layer?.tester_needed === true){
        if(!is_user_tester) return false
    }
    return true
}

const activeOverlayLayers = computed(() => {
    if (settingMode.value)
        return mapStore.overlayLayers.filter(l => l.active)
    else
        return mapStore.overlayLayers
})


const activeUserLayers = computed(() => {
    if (settingMode.value)
        return mapStore.userLayers.filter(l => l.active)
    else
        return mapStore.userLayers
})

const activeAnnotazioniLayers = computed(() => {
    if (settingMode.value)
        return mapStore.annotazioniLayers.filter(l => l.active)
    else
        return mapStore.annotazioniLayers
})


const activeBaseLayers = computed(() => {
    if (settingMode.value)
        return mapStore?.baseLayers.filter(l => l.active)
    else
        return mapStore?.baseLayers
})


// const atLeastOneMBTilesPackDownloaded = computed(() => {
//     return mapStore?.baseLayers.filter(l => l.type == 'mbtiles-single-file').length > 0
// })


const settingMode = ref(false)


const settingColor = computed(() => {
    return settingMode.value ? "red-darken-4" : "blue-grey-darken-4"
})


const deleteUserLayer = (layer) => {
    layer.visible = false
    mapStore.deleteUserLayer(layer.id)
}


const setBaseLayer = (layer) => {
    console.log("--setBaseLayer--", layer)
    emitSelectBaseLayer(layer)
    setBaseLayerID()
}


const toggleLayerVisibility = (layer) => {
    emitToggleLayer(layer)
}


const toggleLayerActivation = (layer) => {
    console.log("--toggleLayerActivation--")
    if (!layer.active) {
        layer.visible = false
    }
    // console.log(layer.active)
    mapStore.saveLayers()
}


// const toggleLayerActivation = (layer) => {
//     layer.active = !layer?.active
//     // console.log(layer)
// }


const geojsonFileAdded = (name) => {
    console.log("geojsonFileAdded", name)
    mapStore.setUserLayers()
}


const geojsonLayerFileInputConfig = {
    fab: false,
    label: "Aggiungi",
    size: "small",
    purpose: "userlayer",
    intro: `
    <span class="text-headline-large">Carica livelli</span><br>(geojson nel formato EPSG:4326)`,
    file: {
        audio: false,
        video: false,
        image: false,
        geojson: true,
    },
    capture: {
        audio: false,
        video: false,
        image: false,
    },
}


const setBaseLayerID = () => {
        // console.log("LayersMenu mounted")

        console.log(activeBaseLayers)
        
        baseLayerID.value = activeBaseLayers?.value?.find(
            l => l.visible === true)?.id
            
            
        if (!baseLayerID.value) {
            console.error("baseLayerID not found")
            console.log(activeBaseLayers)
            
        }
        
        console.log(baseLayerID.value)

    }



    const spm = JSON.parse(localStorage.stambecchiPreviousMonth)
    const spm_length = ref(spm?.features?.length)
    const spm_ca = ref(spm?.properties?.created_at)

onMounted(() => {

    setTimeout(setBaseLayerID, 300)
})


</script>



<style scoped>
#nd-title {
    /* navigation drawer sticky title */
    position: sticky;
    top: 0;
    z-index: 100;
    background: #212121;
}

.v-input--density-compact {
    --v-input-control-height: 0 !important;
    --v-input-padding-top: 0 !important;
}
</style>
